// @flow
import React from 'react';
import { Icon } from 'semantic-ui-react';

import { useIsFedRAMPEstimate } from '../../custom-hooks/useIsFedRAMPEstimate';
import { Spacer } from '../presentational/spacing/Spacer';
import { Badge } from '../presentational/Badge';

import { FEDRAMP_ENABLED_DISPLAY_NAME } from './constants';

export const FedRAMPTagContainer = () => {
  const isFedRAMPEstimate = useIsFedRAMPEstimate();

  if (!isFedRAMPEstimate) {
    return null;
  }

  return (
    <>
      <Spacer x={10} />
      <Badge icon={<Icon name="shield alternate" />} text={FEDRAMP_ENABLED_DISPLAY_NAME} />
    </>
  );
};
